import PageTypeA from "../components/pageTypeA/PageTypeA";
import { pagesDataA } from "../data/pagesData";

const Page14 = () => {
  return (
    <PageTypeA title={pagesDataA[7].title} subtitle={pagesDataA[7].subtitle} image={pagesDataA[7].image}/>
  );
};

export default Page14;
